import React from 'react'
import { useFetchCertificate } from './api'
import apiUrl from '../../apis/api.url'
import { downloadData } from '../../apis/api.helpers'
import bgImg from '../../assets/bg-img.png'

export default function Certificate() {
  const { data, isLoading, isError } = useFetchCertificate({
    page: 1,
    page_size: 10,
  })

  const items = data?.data ?? []

  const handleDownload = async (id: number | string) => {
    try {
      const url = `${apiUrl.DASHBOARD_CERTIFICATE}/${id}/download`
      const blob = await downloadData(url)
      const href = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = href
      a.download = `certificate-${id}.pdf`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(href)
    } catch (e) {
      // optional: surface a toast in your app
      console.error('Failed to download certificate', e)
    }
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-semibold mb-4">Certificates</h1>

      {isLoading && (
        <div className="text-gray-600">Loading certificates...</div>
      )}

      {isError && (
        <div className="text-red-600">Failed to load certificates.</div>
      )}

      {!isLoading && !isError && items.length === 0 && (
        <div className="py-10 text-center">
          <div className="text-base font-semibold text-gray-600">
            No certificates found
          </div>
          <div className="mt-1 text-sm text-gray-400">
            Please check back later.
          </div>
        </div>
      )}

      {!isLoading && !isError && items.length > 0 && (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
          {items.map((item: any) => (
            <div
              key={item.id}
              className="relative bg-white rounded-md shadow-sm border border-gray-200 overflow-hidden"
            >
              <div
                className="absolute inset-0 bg-center bg-cover opacity-10"
                style={{ backgroundImage: `url(${bgImg})` }}
                aria-hidden
              />
              <button
                type="button"
                title="Download certificate"
                onClick={() => handleDownload(item?.id)}
                className="absolute top-5 right-5 z-10 inline-flex items-center justify-center h-7 w-7 rounded-full bg-white/90 border border-gray-200 shadow hover:bg-gray-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4 text-gray-700"
                >
                  <path d="M12 3a1 1 0 011 1v8.586l2.293-2.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L11 12.586V4a1 1 0 011-1z" />
                  <path d="M5 20a2 2 0 01-2-2v-1a1 1 0 112 0v1h14v-1a1 1 0 112 0v1a2 2 0 01-2 2H5z" />
                </svg>
              </button>
              <div className="absolute inset-0 pointer-events-none p-2">
                <div className="h-full w-full border-2 border-yellow-500 rounded-md" />
                <div className="absolute inset-2 border border-gray-300 rounded-md" />
              </div>
              <div className="relative aspect-[3/4] p-5 flex flex-col justify-between">
                <div className="text-center">
                  <div className="text-[9px] uppercase tracking-[0.25em] text-gray-500">
                    Certificate
                  </div>
                  <div className="mt-0.5 text-[10px] uppercase tracking-widest text-gray-600">
                    of Participation
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-base font-semibold text-gray-900 leading-snug">
                    {item?.program?.name
                      ? item.program.name.charAt(0).toUpperCase() +
                        item.program.name.slice(1)
                      : 'Unnamed Program'}
                  </div>
                  <div className="text-xs text-gray-600 mt-1.5">
                    {item?.data?.daysText}
                  </div>
                </div>
                <div className="flex items-center justify-between text-[9px] text-gray-500">
                  {/* <div>Issued by: {item?.issued_by || '—'}</div>
                  <div>{item?.issued_at ? new Date(item.issued_at).toLocaleDateString() : '—'}</div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
